(
    function() {
        'use strict';
        var angular:angular.IAngularStatic =  require('angular');
		var he = require('he');
        angular.module('prmTranslate').
            factory('PrmMissingTranslationHandler', PrmMissingTranslationHandler);

        function PrmMissingTranslationHandler(prmTranslationIdToCodeMapping, $translate) {
            let UNDEFINED_TRANSLATION = 'NOT_DEFINED';

            return function(translationID) {
                let code = prmTranslationIdToCodeMapping.getMapping(translationID);
                let translation = translationID;
                let indexLastField = translationID.lastIndexOf('.');
                if (indexLastField !== -1 && indexLastField !== translationID.length-1) {
                    translation = translationID.substring(indexLastField+1);

                    // Like in the old UI, we are normalizing the code of missinf code tables (replace '_' and '-' with whitespace)
                    translation = translation.replace(/_/g, ' ');
                    translation = translation.replace(/-/g, ' ');
                }
                let backup;
                if(!code){
                    backup= prmTranslationIdToCodeMapping.getMapping(translation);
                    if(backup !== UNDEFINED_TRANSLATION){
                        prmTranslationIdToCodeMapping.setMapping(translation, UNDEFINED_TRANSLATION);
						/* 	PRM-45349
							XSS Vulnerability in Primo search
						*/
						if (he.encode(translation) === translation) {
                        	backup= $translate.instant(translation);
						} else {
							backup = translation;
						}
                        if(backup){
                            prmTranslationIdToCodeMapping.setMapping(translation, backup);
                            prmTranslationIdToCodeMapping.setMapping(translationID, backup);
                        }
                    }
                }
                if (code=== UNDEFINED_TRANSLATION){
                    prmTranslationIdToCodeMapping.setMapping(translation, translation);
                    prmTranslationIdToCodeMapping.setMapping(translationID, translation);
                    return translation;
                }
                return (code || backup) || translation;
            };
        }
        PrmMissingTranslationHandler.$inject = ['PrmTranslationIdToCodeMapping', '$translate'];
    }
)();



// WEBPACK FOOTER //
// ./src/main/webapp/components/translate/prmMissingTranslationHandler.factory.ts